module.exports = __webpack_public_path__ + "static/search-loc-pragma-be7fed0101a863fe3b9b187b38bb31c7.png";